//
// Хук для GET-запроса к API
//
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from '../utils/api';

const useApiGet = ({ method, params }) => {
    const [data, setData] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState('');

	useEffect(() => {
		const fetchData = async () => {
			setIsLoading(true);
			setData(null);
			setError('');
			const result = await get(method, params);
			if(result.error) {
				setError(result.error);
			} else {
				setData(result.data);
			}
			setIsLoading(false);
		};

		fetchData();
	}, [method, params]);

    return [ data, error, isLoading ];
};

useApiGet.propTypes = {
    method: PropTypes.string.isRequired,
    params: PropTypes.object.isRequired,
};

useApiGet.defaultProps = {
	params: {},
};


export default useApiGet;
